import React from "react";
import { CircularProgress } from "@mui/material";
import { GridPreferencePanelsValue, useGridApiContext } from "@mui/x-data-grid";
import {
    SovosBox,
    SovosChipFilter,
    SovosToolbarActions,
    SovosToolbarColumn,
    SovosToolbarGroup,
    SovosTooltip,
    SovosTypography,
} from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const StagingDataToolbar = ({ toolbarProps, defaultToolbarProps }) => {
    const { i18n } = useGlobalValue();
    const {
        aiDisabledReason,
        aiSuggestionsEnabled,
        isSaving,
        loading,
        onOpenAiPanel,
        onToggleErrors,
        showErrorsDisabled,
        showErrorsOnly,
    } = toolbarProps || {};
    const { isPreferencesPanelOpen } = defaultToolbarProps || {};
    const gridRef = useGridApiContext();

    const toggleColumnPanel = () => {
        if (isPreferencesPanelOpen) {
            gridRef.current.hidePreferences();
        } else {
            gridRef.current.showPreferences(GridPreferencePanelsValue.columns);
        }
    };

    return (
        <SovosToolbarGroup
            sx={{
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
            }}
        >
            <SovosTypography variant="body2">
                {i18n`You are validating data format. Fix or proceed with warning`}
            </SovosTypography>
            <SovosToolbarActions>
                <SovosBox sx={{ alignItems: "center", display: "flex", gap: 1.5 }}>
                    <SovosChipFilter
                        disabled={showErrorsDisabled}
                        label={i18n`Show Errors`}
                        onClick={onToggleErrors}
                        selected={showErrorsOnly}
                    />
                    <SovosTooltip
                        title={aiDisabledReason || i18n`Open Sovi AI fix suggestions`}
                        placement="top"
                    >
                        <SovosBox component="span" sx={{ display: "inline-flex" }}>
                            <SovosChipFilter
                                disabled={
                                    !aiSuggestionsEnabled
                                    || !onOpenAiPanel
                                    || !!aiDisabledReason
                                }
                                label={i18n`Show AI suggestion`}
                                onClick={onOpenAiPanel}
                            />
                        </SovosBox>
                    </SovosTooltip>
                </SovosBox>
                {(loading || isSaving) && (
                    <SovosBox sx={{ alignItems: "center", display: "flex", gap: 0.5 }}>
                        <CircularProgress size={12} />
                        <SovosTypography variant="caption" sx={{ color: "text.secondary" }}>
                            {loading ? i18n`Scanning…` : i18n`Saving…`}
                        </SovosTypography>
                    </SovosBox>
                )}
                <SovosBox
                    sx={{
                        alignItems: "center",
                        alignSelf: "stretch",
                        borderLeft: "1px solid",
                        borderColor: "divider",
                        display: "flex",
                        ml: 1.5,
                    }}
                >
                    <SovosToolbarColumn onClick={toggleColumnPanel} />
                </SovosBox>
            </SovosToolbarActions>
        </SovosToolbarGroup>
    );
};

export default StagingDataToolbar;
